import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IAbyssCardLinkProps } from "./AbyssCardLink.props";

export const AbyssCardLink = ({ children, className, link }: IAbyssCardLinkProps) => {
  const classes = cn(
    "group relative block border-t border-iron bg-transparent transition-[background-color,border-color,box-shadow] duration-200 ease-out",
    link &&
      "hover:border-primary hover:bg-surface-200 hover:shadow-[inset_0_1px_0_var(--color-cyan-trace)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

AbyssCardLink.displayName = "Content::AbyssCardLink";
